export default {
    assetProgressBar: {
        width: "100%"
    },
    bars: {
        lineHeight: 0,
        "& :first-of-type": {
            borderTopLeftRadius: "5px",
            borderBottomLeftRadius: "5px"
        },
        "& :last-of-type": {
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px"
        }
    },
    valueBar: {
        display: "inline-block",
        textAlign: "center",
        height: "5px",
        "&:first-of-type": {
            borderTopLeftRadius: "5px",
            borderBottomLeftRadius: "5px"
        },
        "&:last-of-type": {
            borderTopRightRadius: "5px",
            borderBottomRightRadius: "5px"
        }
    }
};
